// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NavOrbTile — the migrated game/social orbs, restyled as bottom-left nav
   tiles matching .pt-orb (Drug Lab / Skill Tree). Migrated 2026-07-19 (Edward)
   from the retired bottom-right MapOrbTray carousel.

   Each tile keeps its old orb color at BASELINE (tinted icon + hairline color
   ring over the same dark glass) so it still reads as the orb it replaced —
   without depending on hover or active. Hover/active brighten the same hue,
   mirroring the amber .pt-orb--active treatment. Colors are driven by four
   CSS vars set per --<orb> modifier below, so the base rules stay single-copy. */

.nav-orb-tile {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid var(--nav-orb-border, rgba(255, 255, 255, 0.10));
  background: rgba(10, 10, 14, 0.55);
  color: var(--nav-orb-color, rgba(214, 211, 209, 0.82));
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 4px 14px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  outline: none;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    transform 0.15s ease;
}

/* Kill the carousel-era spinning ring + pulsing aura on the flat tile. */
.nav-orb-tile [class\$="-orb-ring"] { display: none; }
.nav-orb-tile::before { display: none; }

/* All the orb glyphs were sized 22-24px for the 56px orb; refit to the tile. */
.nav-orb-tile svg { width: 17px; height: 17px; }

.nav-orb-tile:hover {
  background: var(--nav-orb-hover-bg, rgba(255, 255, 255, 0.06));
  border-color: var(--nav-orb-hover-border, rgba(255, 255, 255, 0.22));
  color: var(--nav-orb-hover-color, rgba(245, 245, 244, 0.98));
}

.nav-orb-tile:active { transform: scale(0.96); }

.nav-orb-tile:focus-visible {
  border-color: var(--nav-orb-hover-border, rgba(255, 255, 255, 0.45));
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 0 0 1px var(--nav-orb-hover-border, rgba(255, 255, 255, 0.45)),
    0 4px 14px rgba(0, 0, 0, 0.45);
}

/* Active — surface open / mode on. Stronger colored fill, mirrors .pt-orb--active. */
.nav-orb-tile.is-active {
  border-color: var(--nav-orb-hover-border);
  background: var(--nav-orb-active-bg);
  color: var(--nav-orb-hover-color);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 0 0 1px var(--nav-orb-active-ring),
    0 4px 14px rgba(0, 0, 0, 0.45);
}

/* Locked (PvP < lvl10) — non-interactive, greyed. */
.nav-orb-tile.is-locked {
  opacity: 0.45;
  cursor: not-allowed;
  filter: grayscale(0.4);
}

/* Dim (Reckoning ineligible / not enough unbeaten decks). */
.nav-orb-tile.is-dim {
  opacity: 0.6;
  filter: grayscale(0.4);
}

/* Reckoning pending-count badge (top-right corner pip). */
.nav-orb-tile__badge {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 15px;
  height: 15px;
  padding: 0 3px;
  border-radius: 8px;
  background: #ef4444;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  line-height: 15px;
  text-align: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

/* ── per-orb baseline colors (icon + hairline ring, muted to mesh) ── */
.nav-orb-tile--infection {
  --nav-orb-color: rgba(239, 68, 68, 0.82);
  --nav-orb-border: rgba(239, 68, 68, 0.34);
  --nav-orb-hover-bg: rgba(239, 68, 68, 0.12);
  --nav-orb-hover-border: rgba(239, 68, 68, 0.60);
  --nav-orb-hover-color: rgba(254, 202, 202, 1);
  --nav-orb-active-bg: rgba(239, 68, 68, 0.16);
  --nav-orb-active-ring: rgba(239, 68, 68, 0.38);
}

.nav-orb-tile--molecule {
  --nav-orb-color: rgba(34, 197, 94, 0.85);
  --nav-orb-border: rgba(34, 197, 94, 0.34);
  --nav-orb-hover-bg: rgba(34, 197, 94, 0.12);
  --nav-orb-hover-border: rgba(34, 197, 94, 0.60);
  --nav-orb-hover-color: rgba(187, 247, 208, 1);
  --nav-orb-active-bg: rgba(34, 197, 94, 0.16);
  --nav-orb-active-ring: rgba(34, 197, 94, 0.38);
}

.nav-orb-tile--vaccine {
  --nav-orb-color: rgba(45, 212, 238, 0.86);
  --nav-orb-border: rgba(34, 211, 238, 0.36);
  --nav-orb-hover-bg: rgba(34, 211, 238, 0.12);
  --nav-orb-hover-border: rgba(34, 211, 238, 0.62);
  --nav-orb-hover-color: rgba(165, 243, 252, 1);
  --nav-orb-active-bg: rgba(34, 211, 238, 0.16);
  --nav-orb-active-ring: rgba(34, 211, 238, 0.38);
}

.nav-orb-tile--pvp {
  --nav-orb-color: rgba(251, 113, 133, 0.88);
  --nav-orb-border: rgba(244, 63, 94, 0.38);
  --nav-orb-hover-bg: rgba(244, 63, 94, 0.12);
  --nav-orb-hover-border: rgba(244, 63, 94, 0.64);
  --nav-orb-hover-color: rgba(254, 205, 211, 1);
  --nav-orb-active-bg: rgba(244, 63, 94, 0.16);
  --nav-orb-active-ring: rgba(244, 63, 94, 0.40);
}

.nav-orb-tile--reckoning {
  --nav-orb-color: rgba(248, 113, 113, 0.92);
  --nav-orb-border: rgba(239, 68, 68, 0.46);
  --nav-orb-hover-bg: rgba(239, 68, 68, 0.14);
  --nav-orb-hover-border: rgba(239, 68, 68, 0.70);
  --nav-orb-hover-color: rgba(254, 202, 202, 1);
  --nav-orb-active-bg: rgba(239, 68, 68, 0.18);
  --nav-orb-active-ring: rgba(239, 68, 68, 0.42);
}

.nav-orb-tile--ask {
  --nav-orb-color: rgba(192, 132, 252, 0.90);
  --nav-orb-border: rgba(168, 85, 247, 0.38);
  --nav-orb-hover-bg: rgba(168, 85, 247, 0.14);
  --nav-orb-hover-border: rgba(168, 85, 247, 0.62);
  --nav-orb-hover-color: rgba(233, 213, 255, 1);
  --nav-orb-active-bg: rgba(168, 85, 247, 0.18);
  --nav-orb-active-ring: rgba(168, 85, 247, 0.40);
}
`, "",{"version":3,"sources":["webpack://./src/components/PlayerTray/NavOrbTile.css"],"names":[],"mappings":"AAAA;;;;;;;;iFAQiF;;AAEjF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kEAAkE;EAClE,kCAAkC;EAClC,sDAAsD;EACtD;;kCAEgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,eAAe;EACf;;;;wBAIsB;AACxB;;AAEA,yEAAyE;AACzE,qCAAqC,aAAa,EAAE;AACpD,wBAAwB,aAAa,EAAE;;AAEvC,+EAA+E;AAC/E,oBAAoB,WAAW,EAAE,YAAY,EAAE;;AAE/C;EACE,8DAA8D;EAC9D,oEAAoE;EACpE,4DAA4D;AAC9D;;AAEA,uBAAuB,sBAAsB,EAAE;;AAE/C;EACE,oEAAoE;EACpE;;;kCAGgC;AAClC;;AAEA,qFAAqF;AACrF;EACE,yCAAyC;EACzC,oCAAoC;EACpC,iCAAiC;EACjC;;;kCAGgC;AAClC;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,wEAAwE;AACxE;EACE,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;EAC3C,+CAA+C;EAC/C,6CAA6C;EAC7C,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;EAC3C,+CAA+C;EAC/C,6CAA6C;EAC7C,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,4CAA4C;EAC5C,gDAAgD;EAChD,6CAA6C;EAC7C,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;EAC3C,+CAA+C;EAC/C,6CAA6C;EAC7C,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;EAC3C,+CAA+C;EAC/C,6CAA6C;EAC7C,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,4CAA4C;EAC5C,gDAAgD;EAChD,6CAA6C;EAC7C,6CAA6C;EAC7C,+CAA+C;AACjD","sourcesContent":["/* NavOrbTile — the migrated game/social orbs, restyled as bottom-left nav\n   tiles matching .pt-orb (Drug Lab / Skill Tree). Migrated 2026-07-19 (Edward)\n   from the retired bottom-right MapOrbTray carousel.\n\n   Each tile keeps its old orb color at BASELINE (tinted icon + hairline color\n   ring over the same dark glass) so it still reads as the orb it replaced —\n   without depending on hover or active. Hover/active brighten the same hue,\n   mirroring the amber .pt-orb--active treatment. Colors are driven by four\n   CSS vars set per --<orb> modifier below, so the base rules stay single-copy. */\n\n.nav-orb-tile {\n  position: relative;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid var(--nav-orb-border, rgba(255, 255, 255, 0.10));\n  background: rgba(10, 10, 14, 0.55);\n  color: var(--nav-orb-color, rgba(214, 211, 209, 0.82));\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 4px 14px rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    transform 0.15s ease;\n}\n\n/* Kill the carousel-era spinning ring + pulsing aura on the flat tile. */\n.nav-orb-tile [class$=\"-orb-ring\"] { display: none; }\n.nav-orb-tile::before { display: none; }\n\n/* All the orb glyphs were sized 22-24px for the 56px orb; refit to the tile. */\n.nav-orb-tile svg { width: 17px; height: 17px; }\n\n.nav-orb-tile:hover {\n  background: var(--nav-orb-hover-bg, rgba(255, 255, 255, 0.06));\n  border-color: var(--nav-orb-hover-border, rgba(255, 255, 255, 0.22));\n  color: var(--nav-orb-hover-color, rgba(245, 245, 244, 0.98));\n}\n\n.nav-orb-tile:active { transform: scale(0.96); }\n\n.nav-orb-tile:focus-visible {\n  border-color: var(--nav-orb-hover-border, rgba(255, 255, 255, 0.45));\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 0 0 1px var(--nav-orb-hover-border, rgba(255, 255, 255, 0.45)),\n    0 4px 14px rgba(0, 0, 0, 0.45);\n}\n\n/* Active — surface open / mode on. Stronger colored fill, mirrors .pt-orb--active. */\n.nav-orb-tile.is-active {\n  border-color: var(--nav-orb-hover-border);\n  background: var(--nav-orb-active-bg);\n  color: var(--nav-orb-hover-color);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 0 0 1px var(--nav-orb-active-ring),\n    0 4px 14px rgba(0, 0, 0, 0.45);\n}\n\n/* Locked (PvP < lvl10) — non-interactive, greyed. */\n.nav-orb-tile.is-locked {\n  opacity: 0.45;\n  cursor: not-allowed;\n  filter: grayscale(0.4);\n}\n\n/* Dim (Reckoning ineligible / not enough unbeaten decks). */\n.nav-orb-tile.is-dim {\n  opacity: 0.6;\n  filter: grayscale(0.4);\n}\n\n/* Reckoning pending-count badge (top-right corner pip). */\n.nav-orb-tile__badge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  min-width: 15px;\n  height: 15px;\n  padding: 0 3px;\n  border-radius: 8px;\n  background: #ef4444;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 800;\n  line-height: 15px;\n  text-align: center;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);\n  pointer-events: none;\n}\n\n/* ── per-orb baseline colors (icon + hairline ring, muted to mesh) ── */\n.nav-orb-tile--infection {\n  --nav-orb-color: rgba(239, 68, 68, 0.82);\n  --nav-orb-border: rgba(239, 68, 68, 0.34);\n  --nav-orb-hover-bg: rgba(239, 68, 68, 0.12);\n  --nav-orb-hover-border: rgba(239, 68, 68, 0.60);\n  --nav-orb-hover-color: rgba(254, 202, 202, 1);\n  --nav-orb-active-bg: rgba(239, 68, 68, 0.16);\n  --nav-orb-active-ring: rgba(239, 68, 68, 0.38);\n}\n\n.nav-orb-tile--molecule {\n  --nav-orb-color: rgba(34, 197, 94, 0.85);\n  --nav-orb-border: rgba(34, 197, 94, 0.34);\n  --nav-orb-hover-bg: rgba(34, 197, 94, 0.12);\n  --nav-orb-hover-border: rgba(34, 197, 94, 0.60);\n  --nav-orb-hover-color: rgba(187, 247, 208, 1);\n  --nav-orb-active-bg: rgba(34, 197, 94, 0.16);\n  --nav-orb-active-ring: rgba(34, 197, 94, 0.38);\n}\n\n.nav-orb-tile--vaccine {\n  --nav-orb-color: rgba(45, 212, 238, 0.86);\n  --nav-orb-border: rgba(34, 211, 238, 0.36);\n  --nav-orb-hover-bg: rgba(34, 211, 238, 0.12);\n  --nav-orb-hover-border: rgba(34, 211, 238, 0.62);\n  --nav-orb-hover-color: rgba(165, 243, 252, 1);\n  --nav-orb-active-bg: rgba(34, 211, 238, 0.16);\n  --nav-orb-active-ring: rgba(34, 211, 238, 0.38);\n}\n\n.nav-orb-tile--pvp {\n  --nav-orb-color: rgba(251, 113, 133, 0.88);\n  --nav-orb-border: rgba(244, 63, 94, 0.38);\n  --nav-orb-hover-bg: rgba(244, 63, 94, 0.12);\n  --nav-orb-hover-border: rgba(244, 63, 94, 0.64);\n  --nav-orb-hover-color: rgba(254, 205, 211, 1);\n  --nav-orb-active-bg: rgba(244, 63, 94, 0.16);\n  --nav-orb-active-ring: rgba(244, 63, 94, 0.40);\n}\n\n.nav-orb-tile--reckoning {\n  --nav-orb-color: rgba(248, 113, 113, 0.92);\n  --nav-orb-border: rgba(239, 68, 68, 0.46);\n  --nav-orb-hover-bg: rgba(239, 68, 68, 0.14);\n  --nav-orb-hover-border: rgba(239, 68, 68, 0.70);\n  --nav-orb-hover-color: rgba(254, 202, 202, 1);\n  --nav-orb-active-bg: rgba(239, 68, 68, 0.18);\n  --nav-orb-active-ring: rgba(239, 68, 68, 0.42);\n}\n\n.nav-orb-tile--ask {\n  --nav-orb-color: rgba(192, 132, 252, 0.90);\n  --nav-orb-border: rgba(168, 85, 247, 0.38);\n  --nav-orb-hover-bg: rgba(168, 85, 247, 0.14);\n  --nav-orb-hover-border: rgba(168, 85, 247, 0.62);\n  --nav-orb-hover-color: rgba(233, 213, 255, 1);\n  --nav-orb-active-bg: rgba(168, 85, 247, 0.18);\n  --nav-orb-active-ring: rgba(168, 85, 247, 0.40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
